import type { ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

import { PharaohNextScope } from '#/lib/pharaoh-next/pharaoh-next-scope.tsx'

export function InputDimensionsDocumentationPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <PharaohNextScope surface="bo">
      <LoadingRegion label={translate('loading_aria_label')}>
        <View.Root>
          <View.Header>
            <View.Title className="whitespace-normal">{translate('input_dimensions_per_product_title')}</View.Title>
          </View.Header>
          <View.Body>
            <Skeleton variant="button" width={120} />
            <Skeleton variant="block" height={140} />
            <Skeleton variant="block" height={140} />
          </View.Body>
        </View.Root>
      </LoadingRegion>
    </PharaohNextScope>
  )
}
